import { BoxMargin } from 'tabler-icons-react';
import {
  ECOM_ENTITY_TYPES,
  ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM
} from '../../../../../config/constants';
import WsDesignBlock from './WsDesignBlock';

const configNameValues = { ecomStoreDesign: 'ecomStoreDesign' };

const configDefaultValues = { ecomStoreDesign: '' };

const configOptions = {
  [configNameValues.ecomStoreDesign]: {
    label: 'Design',
    type: 'entity',
    selectAllDisabled: true,
    entityType: ECOM_ENTITY_TYPES.ecomStoreDesign
  }
};

const config = {
  title: 'Design',
  type: ECOM_WEBSTORE_SECTION_BLOCK_TYPE_ENUM.DESIGN,
  icon: BoxMargin,
  Component: WsDesignBlock,
  configOptions,
  defaultConfig: configDefaultValues,
  getTitle: (c) => c.text,
  onFetchDataConfig: (blockConfigValues) => ({
    type: 'ecomStoreDesigns',
    entityId: blockConfigValues.ecomStoreDesign,
    filter: {}
  })
};

export { config, configOptions, configNameValues, configDefaultValues };
